import { LocationScope, LocationVarInheritance } from "@swivl-mono/types";
import { InheritancePill, Spinner, Tooltip } from "@swivl-mono/ui";
import { AiOutlineInfoCircle } from "react-icons/ai";

import "./WorksheetComponent.Label.css";

interface Props {
  text?: string;
  inheritance: LocationVarInheritance;
  isEditing: boolean;
  type: LocationScope;
  canRevert: boolean;
  isLoading: boolean;
  deleteVariable(): void;
  inline?: boolean;
  tooltip?: string;
}

export function WorksheetComponentLabel(props: Props) {
  const { inheritance, isEditing, isLoading, deleteVariable } = props;
  const revert = () => {
    if (confirm("Are you sure you want to revert this variable?")) {
      deleteVariable();
    }
  };

  return (
    <div className={`WorksheetComponentLabel mb-0.5 ${props.inline ? "inlineLabel" : ""}`}>
      <div className="labelText">
        {isLoading ? <Spinner /> : props.text || ""}
        {props.tooltip && (
          <Tooltip content={props.tooltip} placement="top">
            <AiOutlineInfoCircle
              className="ml-1 inline-block cursor-help text-grey-600 hover:text-grey-800"
              style={{ fontSize: "14px", verticalAlign: "middle" }}
            />
          </Tooltip>
        )}
      </div>
      <InheritancePill inheritance={inheritance} isEditing={isEditing} canRevert={props.canRevert} onClick={revert} />
    </div>
  );
}
